import { useTheme } from "@mui/material";
import {
  ExperienceActionDto,
  ExperienceListDto,
  ScheduleDto,
  TabEnumFe,
} from "@intelligems/ig-types";
import {
  IgChip,
  IgTooltip,
  IgTypography,
  IgTypographyTooltip,
} from "@intelligems/ig-theme";
import { getDaysFromHistory } from "@intelligems/ig-analytics";
import { getRuntimeDisplayLabel } from "@src/domains/experienceTablePages/experienceRuntime";

export const RuntimeLabel = ({
  experienceActions,
  hasExpEverStarted,
}: {
  experienceActions: ExperienceActionDto[];
  hasExpEverStarted: boolean;
}) => {
  const theme = useTheme();

  if (!hasExpEverStarted) {
    return <IgTypography color={theme.palette.text.secondary}>-</IgTypography>;
  }

  const runtimeDays = Math.ceil(getDaysFromHistory(experienceActions));
  const label = getRuntimeDisplayLabel(runtimeDays);

  return (
    <IgTypography color={theme.palette.text.secondary} variant={"body1"}>
      {label}
    </IgTypography>
  );
};
